import { makeStyles } from '@material-ui/core/styles';

export const usePaginationStyles = makeStyles(
  theme => ({
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: theme.spacing(1, 0),
      marginRight: theme.spacing(2),
      marginLeft: theme.spacing(1),
      borderTop: `1px solid ${theme.palette.divider}`
    },
    controls: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1)
    },
    info: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(2),
      fontSize: theme.typography.body2.fontSize,
      color: theme.palette.text.secondary
    },
    pageButton: {
      minWidth: theme.spacing(4),
      height: theme.spacing(4),
      padding: theme.spacing(0.5),
      borderRadius: theme.shape.borderRadius,
      fontWeight: 400
    },
    itemsPerPageContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(2)
    }
  }),
  { name: 'Pagination' }
);
